import React, { useState } from "react";

import { Icon } from "semantic-ui-react";
import { AppRow } from "../../../UI/Layouts";
import { SizedBox } from "../../../UI/Sizes";
import useTheme from "../../../../hooks/useTheme";
import AppPrimaryTextfield from "../../../UI/TextInput";
import { withOpacity } from "../../../../utils/helperFunctions";
import randomstring from "randomstring";
import { SEND_CHAT_MESSAGE } from "../../../../utils/Controller/URLConstants";

import axios from "axios";
import { useResponsive } from "../../../UI/ResponsiveContext";
import AppText from "../../../UI/Texts/AppTexts";
import { VerticalDivider } from "../../../UI/CustomElements";
import { uploadFileWithDetails } from "../../../../utils/firebase/storageFunctions";
import { APP_MODAL } from "../../../Modals/AppModal";
import { t } from "i18next";
import UploadProfileDocument from "../../../UserProfilePage/Components/UploadProfileDocument";
import { getSessionToken } from "../../../../utils/sessionFunctions";

export const MessageFooter = ({
  selectedChatId,
  currentUser,
  showToast,
  openModal,
  closeModal,
  parentMessageId,
}) => {
  const { isMobile } = useResponsive();
  const theme = useTheme();

  const currentUserId = currentUser?.uid;

  const [text, setText] = useState("");
  const [rawLocalFileData, setRawLocalFileData] = useState(null);

  const [isSendingMessage, setIsSendingMessage] = useState(false);
  const [pendingMessageId, setPendingMessageId] = useState(null);

  const hasText = text && text.trim().length > 0;

  function getFileNameFromLocalFile(rawFileData) {

    if (rawFileData?.serverData) {
      return rawFileData.serverData.fileName;
    }

    return rawFileData?.localFile?.name;
  }

  async function onSend(value, newRawLocalFileData) {
    if (isSendingMessage) return false;
    let serverFileData;
    setIsSendingMessage(true);

    try {
      if (newRawLocalFileData) {
        if (newRawLocalFileData?.serverData) {
          serverFileData = Object.assign({}, newRawLocalFileData.serverData, {
            type: newRawLocalFileData?.type,
            fileName: newRawLocalFileData?.fileName,
          });
        } else {
          serverFileData = await uploadFileWithDetails({
            fileData: newRawLocalFileData?.localFile,
            type: newRawLocalFileData?.type,
            fileName: newRawLocalFileData?.fileName,
            folderPath: `chats/${selectedChatId}`,
            onProgress: (_) => {},
          });
          setRawLocalFileData({
            ...newRawLocalFileData,
            serverData: serverFileData,
          });
        }
      }

      if (!((value && value.trim().length > 0) || serverFileData)) return false;
      const messageId = pendingMessageId ??
        `msg_${randomstring.generate({ charset: "alphanumeric", length: 16 })}`;
      setPendingMessageId(messageId);
      const chatId = selectedChatId ??
        `chat_${randomstring.generate({ charset: "alphanumeric", length: 16 })}`;

      const chatMessageData = {
        messageId,
        userId: currentUserId,
        chatId,
        contentData: {
          type: serverFileData ? "file" : "text",
          text: value || "",
          metaData: serverFileData ? {
            fileData: serverFileData,
            chatJobData: null,
          } : null,
        },
        status: "active",
        createdAt: new Date().getTime(),
        seenBy: [currentUserId],
      };

      const token = await getSessionToken();
      const response = await axios.post(
        SEND_CHAT_MESSAGE,
        {
          chatId,
          message: JSON.stringify(chatMessageData),
          parentMessageId: parentMessageId || null,
        },
        {headers: token ? {"x-access-token": token} : {}},
      );

      if (response.data.status === 0) {
        if (serverFileData) {
          showToast(t("document_added"), { type: "success" });
        }
        setPendingMessageId(null);
        return true;
      }
      return false;
    } catch (error) {
      console.log(error);
      showToast(t("something_went_wrong"), {type: "error"});
      return false;
    } finally {
      setIsSendingMessage(false);
    }
  }

  function onChangeText(value) {
    setPendingMessageId(null);
    setText(value);
  }

  const onSendMessage = async () => {
    if (!isSendingMessage) {
      const sent = await onSend(text, rawLocalFileData);
      if (sent) {
        setRawLocalFileData(null);
        setText("");
      }
    }
  };

  const hasTextOrFile = hasText || rawLocalFileData;

  const mobileStyle = {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    backgroundColor: theme.colors.white,
  };

  return (
    <div
      style={{
        maxHeight: "20vh",
        minHeight: "10vh",
        backgroundColor: theme.colors.white,

        ...(isMobile && mobileStyle),
      }}
    >
      {isMobile && <SizedBox height={theme.spacing.elementPadding} />}
      <AppRow
        crossAxisAlignment={"start"}
        style={{
          paddingLeft: isMobile
            ? theme.spacing.elementPadding
            : theme.spacing.contentPadding,
          paddingRight: isMobile && theme.spacing.elementPadding,
        }}
      >
        {
          <AppRow
            style={{
              marginBottom: "0.25rem",
            }}
            onClick={() => {
              if (rawLocalFileData) {
                setPendingMessageId(null);
                setRawLocalFileData(null);
              } else {
                // handleClick();
                // onSendMessage();

                openModal(APP_MODAL, {
                  width: isMobile ? "100%" : "50%",
                  children: (
                    <UploadProfileDocument
                      closeModal={closeModal}
                      type={null}
                      onDone={(data) => {
                        closeModal();
                        setPendingMessageId(null);

                        setRawLocalFileData({
                          localFile: data?.localFile,
                          serverData: data?.serverData,
                          type: data.type,
                          fileName: data.fileName,
                        });
                      }}
                    />
                  ),
                  padding: "0px",
                });
              }
            }}
          >
            {/* <input
                            id={'upload-doc-chat'}
                            type="file"
                            accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
                            style={{
                                borderRadius: "0px",
                                display: "none",
                            }}
                            onChange={handleFileChange}
                        /> */}
            <div
              style={{
                height: hasText ? "30px" : "50px",
                width: hasText ? "30px" : "50px",
                cursor: !isSendingMessage && "pointer",
                backgroundColor: !hasText && theme.colors.lightGrey,
                borderRadius: "999%",
                justifyContent: "center",
                alignContent: "center",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Icon
                name={
                  rawLocalFileData
                    ? "close"
                    : hasText
                      ? "plus"
                      : "file alternate outline"
                }
                style={{
                  color: theme.colors.dark,
                  fontSize: rawLocalFileData ? "15px" : "20px",
                  paddingLeft: hasText ? "8px" : "4px",
                  paddingBottom: "6px",
                  paddingTop: hasText && "8px",
                }}
              />
            </div>
            <SizedBox width={theme.spacing.elementPadding} />
          </AppRow>
        }

        <div
          style={{
            width: "100%",
            paddingBottom: theme.spacing.contentPadding,
          }}
        >
          <AppPrimaryTextfield
            onSubmit={onSendMessage}
            value={text}
            fluid
            minLines={1}
            maxLines={rawLocalFileData ? 2 : 5}
            onChange={onChangeText}
            hintText={t("chat.write_message")}
            files={
              <div>
                {rawLocalFileData && (
                  <AppRow>
                    <AppRow
                      style={{
                        margin: theme.spacing.elementPaddingSmall,
                        backgroundColor: theme.colors.lightGrey,
                        padding: theme.spacing.elementPadding,
                        borderRadius: theme.radius.small,
                      }}
                    >
                      {(() => {
                        const fileType = rawLocalFileData?.localFile?.type;
                        if (fileType && fileType.includes("image")) {
                          return <Icon name="file image outline" />;
                        }
                        return <Icon name="file alternate outline" />;
                      })()}
                      {!isMobile && (
                        <AppRow>
                          <SizedBox width={theme.spacing.elementPaddingSmall} />
                          <AppText.Footnote fontWeight={600}>
                            {getFileNameFromLocalFile(rawLocalFileData)}
                          </AppText.Footnote>
                          <SizedBox width={theme.spacing.elementPaddingSmall} />
                          <VerticalDivider height="20px" />
                          <Icon
                            name="close"
                            onClick={() => {
                              setPendingMessageId(null);
                              setRawLocalFileData(null);
                            }}
                            style={{
                              cursor: "pointer",
                              color: theme.colors.dark,
                              marginLeft: theme.spacing.elementPaddingSmall,
                            }}
                          />
                        </AppRow>
                      )}
                    </AppRow>
                  </AppRow>
                )}
              </div>
            }
          />
        </div>
        <SizedBox width={theme.spacing.elementPadding} />
        <div
          onClick={onSendMessage}
          style={{
            height: isMobile ? "46px" : "50px",
            width: isMobile ? "65px" : "50px",
            cursor: !isSendingMessage && "pointer",
            backgroundColor:
              !hasTextOrFile || isSendingMessage
                ? withOpacity(theme.primaryColor, "0.4")
                : theme.primaryColor,
            borderRadius: theme.radius.small,
            justifyContent: "center",
            alignContent: "center",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
          }}
        >
          {isSendingMessage ? (
            <Icon
              name="circle notch"
              loading
              size="large"
              style={{
                color: theme.colors.white,
              }}
            />
          ) : (
            <Icon
              name="paper plane"
              size="large"
              style={{
                color: theme.colors.white,
              }}
            />
          )}
        </div>
      </AppRow>
      <SizedBox height={theme.spacing.elementPadding} />
    </div>
  );
};
